/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

import { parse } from 'hub-http/helpers/params';
import { fromString } from 'UIComponents/core/SimpleDate';
import * as FILTERS from '../constants/reportFilters';
import { initialState } from '../reducers/reportsReducer';
export const URL_DATE_FORMAT = 'MM-DD-YYYY';
export default (() => {
  const {
    search
  } = location;
  const params = parse(search.replace(/^\?/, ''));
  const {
    dashboardId,
    selectAll
  } = params;
  const initialFilters = Object.assign({}, initialState.get('filters').toJS(), {
    dashboardId
  });
  const queryFilters = Object.keys(FILTERS).reduce((acc, key) => {
    const filterType = FILTERS[key];
    const paramValue = params[filterType];
    return paramValue ? Object.assign({}, acc, {
      [filterType]: filterType === FILTERS.BUSINESS_UNIT ? paramValue.split(',').map(Number) : paramValue
    }) : acc;
  }, {});
  if (params.startDate && params.endDate) {
    queryFilters[FILTERS.UPDATED_AT] = {
      startDate: fromString(params.startDate, URL_DATE_FORMAT),
      endDate: fromString(params.endDate, URL_DATE_FORMAT)
    };
  }
  if (params.lastViewedAt) {
    queryFilters[FILTERS.LAST_VIEWED_AT] = {
      date: fromString(params.lastViewedAt, URL_DATE_FORMAT)
    };
  }
  if (queryFilters[FILTERS.IN_DASHBOARD] || queryFilters[FILTERS.FAVORITES] || queryFilters[FILTERS.UNUSED]) {
    initialFilters[FILTERS.CUSTOM_REPORTS] = undefined;
  }
  return {
    reportFilters: Object.assign({}, initialFilters, queryFilters, {
      selectAll
    })
  };
});